var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12H15.6667C15.2246 12 14.8007 12.1756 14.4882 12.4882C14.1756 12.8007 14 13.2246 14 13.6667V27C14 27.442 14.1756 27.866 14.4882 28.1785C14.8007 28.4911 15.2246 28.6667 15.6667 28.6667H25.6667C26.1087 28.6667 26.5326 28.4911 26.8452 28.1785C27.1577 27.866 27.3333 27.442 27.3333 27V17.8333M21.5 12L27.3333 17.8333M21.5 12V17.8333H27.3333",
    stroke: "#146C94",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8e7fce97a05a49c2e5d94cfe5a203faf.svg";
export { ForwardRef as ReactComponent };